<div class="relative flex flex-col">
  <label for="hairstyle" class="sr-only">Hairstyle</label>
  <input type="text" name="hairstyle" id="hairstyle" placeholder="Hairstyle"
    class="rounded-full min-h-11 pl-8 pr-4 focus:outline-none lg:text-sm" autocomplete="off" (focus)="handleFocus()"
    (blur)="handleBlur()" (input)="handleSearch()" [(ngModel)]="searchTerm">
  <div class="absolute pointer-events-none left-2 top-1/2 -translate-y-1/2">
    <icon-search [size]="18" />
  </div>
  @if (showResults()) {
  <div
    class="absolute z-10 top-full translate-y-1.5 lg:translate-y-3 p-1 rounded-xl border border-gray-200 w-full max-h-[154px] overflow-y-auto bg-white lg:w-60"
    data-lenis-prevent>
    @if (noResults()) {
    <div class="text-center text-gray-500 text-sm py-4 px-4 bg-gray-50 rounded-md">No results
      found
    </div>
    } @else {
    @for (hairstyle of filteredHairstyles(); track $index) {
    <button type="button" (mousedown)="handleSelectHairstyle(hairstyle.nom)"
      class="px-4 py-2 hover:bg-gray-200 rounded-md text-[#515151] flex justify-start text-left text-nowrap w-full text-sm">
      {{ hairstyle.nom }}
    </button>
    }
    }
  </div>
  }
</div>